
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'
import type { ClusterFeatureEntity, DispatcherWorkplacePeriod, DispatcherWorkplaceChangeDateForTakePayload, DispatcherWorkplaceTake } from '@/modules/DispatcherWorkplaceModule/types'

import type { PropType } from 'vue'

import { defineComponent, reactive, onBeforeMount } from 'vue'

import DwPopup from '@/modules/DispatcherWorkplaceModule/ui/DwPopup/index.vue'
import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import { dispatcherWorkplaceAPI } from '@/modules/DispatcherWorkplaceModule/services'
import { DataState } from '@/core/classes/DataState.class'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        DwPopup,
        DwButton,
        TheInput,
        TheSelect,
    },
    props: {
        feature: {
            type: [Object, null] as PropType<ClusterFeature<ClusterFeatureEntity> | null>,
            default: null
        }
    },
    emits: ['close', 'date-changed'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            newDate: null as string | null,
            periodId: null as number | null,
        })

        const data_state = reactive({
            periods: new DataState<DispatcherWorkplacePeriod>({}),
        })
        
        const loadPeriods = async () => {
            data_state.periods.pagination.current_page = 1

            try {
                data_state.periods.is_loading = true
                const response = await dispatcherWorkplaceAPI.loadPeriodsForChangeDate()
                data_state.periods.list = response.data.data

                data_state.periods.pagination.total_pages = 1

                data_state.periods.is_failed = false
                data_state.periods.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.periods.failure.catchError(error)

                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_failed = true
                }
            } finally {
                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_loading = false
                }
            }
        }

        const notifications = useNotifications()
        const validation$ = useVuelidate({ newDate: { required }, periodId: { required }}, state)

        const onClose = () => {
            if (state.is_loading) return
            emit('close')
        }

        const onSubmit = async () => {
            if (!props.feature || !props.feature.entity || props.feature.entity.type !== 1 || state.is_loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            try {
                state.is_loading = true

                if (props.feature.entity.type === 1) {
                    const payload: DispatcherWorkplaceChangeDateForTakePayload = {
                        orderId: (props.feature.entity as DispatcherWorkplaceTake).orderId,
                        newDate: state.newDate as string,
                        periodId: state.periodId
                    }

                    await dispatcherWorkplaceAPI.changeDateForTake(payload)
                    notifications.notify({ type: 'success', title: 'Дата перенесена' })
        
                    emit('date-changed', props.feature)
                }
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При переносе даты произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadPeriods)

        return {
            state,
            data_state,
            validation$,
            loadPeriods,
            onClose,
            onSubmit,
        }
    }
})
